import { render, staticRenderFns } from "./SearchMessages.vue?vue&type=template&id=8f90425c&lang=pug"
import script from "./SearchMessages.vue?vue&type=script&lang=js"
export * from "./SearchMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports